/* eslint-disable @typescript-eslint/ban-ts-comment */
import { BaseCompoundFormFieldBuilder } from '.';
import { FileFormField, FormFieldType, GridSize } from '../typings';

export class FileFormFieldBuilder extends BaseCompoundFormFieldBuilder<FileFormField> {
  protected _type = FormFieldType.File;
  protected _typeValue = FormFieldType.File;
  // @ts-ignore
  private _label: FileFormField['label'] = 'Label not provided';
  // @ts-ignore
  private _readonly: FileFormField['readonly'] = false;
  // @ts-ignore
  private _size: FileFormField['size'] = { md: 12 };
  // @ts-ignore
  private _isRequired?: FileFormField['isRequired'];
  // @ts-ignore
  private _maxFileCount: FileFormField['maxFileCount'] = 1;
  // @ts-ignore
  private _minFileCount: FileFormField['minFileCount'] = 0;
  // @ts-ignore
  private _restriction?: FileFormField['restriction'];
  // @ts-ignore
  private _fileNames: FileFormField['fileNames'] = {};

  constructor() {
    super();
  }

  public label(value: FileFormField['label']): this {
    this._label = value;
    return this;
  }

  public readonly(value: FileFormField['readonly']): this {
    this._readonly = value;
    return this;
  }

  public isRequired(value: FileFormField['isRequired']): this {
    this._isRequired = value;
    return this;
  }

  public size(value: GridSize): this {
    this._size = { md: value };
    return this;
  }

  public maxFileCount(value: FileFormField['maxFileCount']): this {
    this._maxFileCount = value;
    return this;
  }

  public minFileCount(value: FileFormField['minFileCount']): this {
    this._minFileCount = value;
    return this;
  }

  public restriction(value: FileFormField['restriction']): this {
    this._restriction = value;
    return this;
  }

  public fileNames(value: FileFormField['fileNames']): this {
    this._fileNames = value;
    return this;
  }
}
